import {
	createContext,
	PropsWithChildren,
	ReactNode,
	useContext,
	useState,
} from 'react';

interface LayoutContextType {
	isOpen: boolean;
	subMenuOpen?: string;
	isSubMenuOpen: (path: string) => boolean;
	setSubMenu: (path?: string) => void;
	setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const LayoutContext = createContext({} as LayoutContextType);
export function LayoutProvider({ children }: PropsWithChildren<ReactNode>) {
	const [isOpen, setIsOpen] = useState(false);
	const [subMenuOpen, setSubMenuOpen] = useState<string>();

	const setSubMenu = (path?: string) => {
		if (subMenuOpen === path) {
			setSubMenuOpen(undefined);
		} else {
			setSubMenuOpen(path);
		}
	};

	const isSubMenuOpen = (path: string) => {
		return subMenuOpen === path;
	};

	const value = {
		isOpen,
		setIsOpen,
		setSubMenu,
		subMenuOpen,
		isSubMenuOpen,
	};

	return (
		<LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>
	);
}

export function useLayoutContext() {
	return useContext(LayoutContext);
}
